import { defineMessages } from 'react-intl';

export default defineMessages({
  cart_title: {
    id: 'app.cart.containers.Cart.cart_title',
    defaultMessage: 'Mi pedido',
  },
  cart_title_pickup: {
    id: 'app.cart.containers.Cart.cart_title_pickup',
    defaultMessage: 'Mi pedido a retirar',
  },
  cart_add_more_items: {
    id: 'app.cart.containers.Cart.cart_add_more_items',
    defaultMessage: 'Seguir comprando',
  },
  cart_add_more_items_to_reach_minimum: {
    id: 'app.cart.containers.Cart.cart_add_more_items_to_reach_minimum',
    defaultMessage: 'Agrega {needsToAdd} para alcanzar el mínimo',
  },
  cart_add_more_items_to_reach_minimum_new: {
    id: 'app.cart.containers.Cart.cart_add_more_items_to_reach_minimum_new',
    defaultMessage: 'Agregar {needsToAdd} para continuar',
  },
  cart_open_edit_mode: {
    id: 'app.cart.containers.Cart.cart_open_edit_mode',
    defaultMessage: 'Editar',
  },
  cart_close_edit_mode: {
    id: 'app.cart.containers.Cart.cart_close_edit_mode',
    defaultMessage: 'Listo',
  },
  remove_products: {
    id: 'app.cart.containers.Cart.removeProducts',
    defaultMessage:
      'Tu DNI indica que sos menor de edad. Para continuar, editá y eliminá de tu carrito los productos resaltados.',
  },
  error_retry: {
    id: 'app.cart.containers.Cart.errorRetry',
    defaultMessage:
      'Uy! No pudimos confirmar tu edad. Por favor volvé a intentarlo',
  },
  error_retry_toast_action: {
    id: 'app.cart.containers.Cart.errorRetryToastAction',
    defaultMessage: 'Reintentar',
  },
  cart_footer_continue: {
    id: 'app.cart.containers.Cart.components.footer.continue',
    defaultMessage: 'Continuar',
  },
  cart_footer_go_pay: {
    id: 'app.cart.containers.Cart.components.footer.goPay',
    defaultMessage: 'Ir a pagar',
  },
  cart_footer_remove: {
    id: 'app.cart.containers.Cart.components.footer.remove',
    defaultMessage: 'Eliminar seleccionados',
  },
  cart_shop_limit_products: {
    id: 'app.cart.containers.Cart.components.toast.limit',
    defaultMessage:
      'Este local tiene un límite de {shopMaxProducts} unidades. Modifica tu pedido para continuar.',
  },
  cart_list_title: {
    id: 'app.cart.containers.Cart.cartListTitle',
    defaultMessage: 'Estás llevando:',
  },
  cart_list_title_pickup: {
    id: 'app.cart.containers.Cart.cartListTitlePickUp',
    defaultMessage: 'Vas a retirar:',
  },
  qr_web_modal_title: {
    id: 'app.cart.qrWebModal.title',
    defaultMessage: 'Escaneá el QR para continuar tu compra',
  },
  qr_web_modal_text: {
    id: 'app.cart.qrWebModal.text',
    defaultMessage:
      'Con el código QR vas a poder abrir la app y pagar tu pedido',
  },
  qr_mobile_modal_title: {
    id: 'app.cart.qrMobileModal.title',
    defaultMessage: 'Terminá tu compra desde la app',
  },
  qr_mobile_modal_text: {
    id: 'app.cart.qrMobileModal.text',
    defaultMessage:
      'Guardamos tu pedido para que lo pagues desde la App. Abrila o descargala para continuar.',
  },
  qr_modal_continue_button_label: {
    id: 'app.cart.qrModalContinueButtonLabel.text',
    defaultMessage: 'Entendido',
  },
});
